import "./AddClass.css";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import AddClassViewModel from "./AddClassViewModel";
import IsSchoolAdded from "../../../../Hooks/IsSchoolAdded";
import ReactSelect from "../../../../Components/Select/React-Select";

const AddClass = () => {
  const {
    RegisterClass,
    FormDisabled,
    AddClass,
    setAddClass,
    ClassNameError,
    ClassCodeError,
    ClassSessionError,
    IsUpdate,
  } = AddClassViewModel();

  const SchoolAddedResp = IsSchoolAdded();

  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper admin-add-class-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">
                  {IsUpdate ? "Update Class" : "Add Class"}
                </h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/user/admin/class-courses">
                      Classes and Courses
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">Add Class</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form>
                    <div className="row">
                      <div className="col-12">
                        <h5 className="form-title">
                          <span>Class Details</span>
                        </h5>
                        {!SchoolAddedResp && (
                          <div className="add-school-first-container">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              class="bi bi-exclamation-triangle-fill"
                              viewBox="0 0 16 16"
                            >
                              <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                            </svg>
                            <p>Please add school first!</p>
                          </div>
                        )}
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Class Name <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              ClassNameError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddClass({
                                ...AddClass,
                                ClassName: e.target.value,
                              });
                            }}
                            value={AddClass.ClassName}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {ClassNameError === true ? (
                            <span className="admin-add-class-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Class name is required and can not be less than
                                3 characters
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-class-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Class name is required and can not be less than
                                3 characters
                              </span>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Class Code <span className="login-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              ClassCodeError === true && "error-message"
                            }`}
                            type="text"
                            onChange={(e) => {
                              setAddClass({
                                ...AddClass,
                                ClassCode: e.target.value,
                              });
                            }}
                            value={AddClass.ClassCode}
                            disabled={FormDisabled || !SchoolAddedResp}
                          />
                          {ClassCodeError === true ? (
                            <span className="admin-add-class-tooltip">
                              <i className="fa-solid fa-info icon-after-submit"></i>
                              <span className="text-after-submit">
                                Unique code more then 3 characters
                              </span>
                            </span>
                          ) : (
                            <span className="admin-add-class-tooltip">
                              <i className="fa-solid fa-info text-info"></i>
                              <span className="tooltip-text">
                                Class code is required it must me more then 3
                                characters
                              </span>
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-sm-4">
                        <div className="form-group local-forms">
                          <label>
                            Select session
                            <span className="register-danger">*</span>
                          </label>
                          <ReactSelect
                            disabled={FormDisabled || !SchoolAddedResp}
                            handleChange={(val) => {
                              setAddClass({
                                ...AddClass,
                                Session: val,
                              });
                            }}
                            error={ClassSessionError === true ? true : false}
                            options={[
                              {
                                value: "Please select season",
                                label: "Please select season",
                                isDisabled: true,
                              },
                              { value: "2023-2024", label: "2023-2024" },
                              { value: "2024-2025", label: "2024-2025" },
                              { value: "2025-2026", label: "2025-2026" },
                              { value: "2026-2027", label: "2026-2027" },
                              { value: "2027-2028", label: "2027-2028" },
                            ]}
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="student-submit">
                          <button
                            type="submit"
                            className="btn btn-primary"
                            onClick={(e) => {
                              e.preventDefault();
                              RegisterClass();
                            }}
                            disabled={FormDisabled || !SchoolAddedResp}
                          >
                            {IsUpdate ? "Update" : "Submit"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default AddClass;
